var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Moje kravičky")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-banner --small d-flex" }, [
                        _c("div", { staticClass: "m-banner__left" }, [
                          _c("h3", { staticClass: "a-banner__title" }, [
                            _vm._v("Adoptuj si ďalšiu kravičku")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "a-banner__description" }, [
                            _vm._v("Na výber je ešte "),
                            _c("span", { staticClass: "count" }, [
                              _vm._v(_vm._s(_vm.volneKravicky))
                            ]),
                            _vm._v(" "),
                            _vm.volneKravicky == 1
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                    kravička\n                                "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.volneKravicky > 1 && _vm.volneKravicky < 5
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                    kravičky\n                                "
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n                                    kravičiek\n                                "
                                  )
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(
                          _vm.profil.pouzivatel_id.kravicky_pouzivatela,
                          function(kravicka, index) {
                            return _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-sm-12 col-md-6 col-lg-4"
                              },
                              [
                                kravicka.kravicka_status == 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "o-cowCard mb-3 mb-sm-3 mb-md-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "m-cowCard__image",
                                            style: [
                                              {
                                                "background-image":
                                                  "url(assets/img/produkty/background/" +
                                                  kravicka.kravicka_pozadie_profil +
                                                  ")"
                                              }
                                            ]
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "a-cowCard_head img-fluid",
                                              attrs: {
                                                src:
                                                  "https://www.adoptujkravicku.sk/data/foto/" +
                                                  kravicka.kravicka_img_hlava,
                                                alt: ""
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "m-cowCard__body" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass: "a-cowCard__title"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(kravicka.kravicka_meno)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "a-cowCard__health"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon-heart"
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.roundNumber(
                                                      kravicka.kravicka_param_global
                                                    )
                                                  ) +
                                                    "%\n                                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.profil.pouzivatel_id
                                              .farma_pouzivatela.length != 0
                                              ? _c("div", [
                                                  kravicka.farma_kravicka.length
                                                    ? _c("span", [
                                                        _vm.btnText[index] == 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "a-cowCard__add",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.addCowToFarm(
                                                                      index,
                                                                      kravicka.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "kravicky"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "icon-plus"
                                                                    }),
                                                                    _vm._v(
                                                                      "Pridať na farmu\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "a-cowCard__remove",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCowFromFarm(
                                                                      index,
                                                                      kravicka.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "kravicky"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "icon-close"
                                                                    }),
                                                                    _vm._v(
                                                                      "Odstrániť z farmy\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                      ])
                                                    : _c("span", [
                                                        _vm.btnText[index] == 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "a-cowCard__remove",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCowFromFarm(
                                                                      index,
                                                                      kravicka.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "kravicky"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "icon-close"
                                                                    }),
                                                                    _vm._v(
                                                                      "Odstrániť z farmy\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "a-cowCard__add",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.addCowToFarm(
                                                                      index,
                                                                      kravicka.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "router-link",
                                                                  {
                                                                    attrs: {
                                                                      to: {
                                                                        name:
                                                                          "kravicky"
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "icon-plus"
                                                                    }),
                                                                    _vm._v(
                                                                      "Pridať na farmu\n                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                      ])
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "btn --primary",
                                                attrs: {
                                                  to: {
                                                    name: "kravicka",
                                                    params: {
                                                      kravicka_id: kravicka.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Postarať sa\n                                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "m-cowCard__buttons" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "a-cowCard__birthlist",
                                                attrs: {
                                                  href:
                                                    "https://adoptujkravicku.sk/hra/kravicka/rodny-list/" +
                                                    kravicka.id
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "a-cowCard__edit",
                                                attrs: {
                                                  to: {
                                                    name: "uprava-kravicky",
                                                    params: {
                                                      kravicka_id: kravicka.id,
                                                      kravicka_meno:
                                                        kravicka.kravicka_meno,
                                                      kravicka_meno_rodica:
                                                        kravicka.kravicka_meno_rodica
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                kravicka.kravicka_status == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "o-cowCard mb-3 mb-sm-3 mb-md-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "m-cowCard__image",
                                            style: [
                                              kravicka.kravicka_pozadie_profil
                                                ? {
                                                    background:
                                                      "url(" +
                                                      kravicka.kravicka_pozadie_profil +
                                                      ")"
                                                  }
                                                : ""
                                            ]
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "a-cowCard_head img-fluid",
                                              attrs: {
                                                src:
                                                  "https://www.adoptujkravicku.sk/data/foto/" +
                                                  kravicka.kravicka_img_hlava,
                                                alt: ""
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "m-cowCard__body" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass: "a-cowCard__title"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(kravicka.kravicka_meno)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(1, true),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "btn --primary",
                                                attrs: {
                                                  to: {
                                                    name: "adopcia-ean",
                                                    params: {
                                                      kravicka_id: kravicka.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Pridať EAN\n                                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "m-cowCard__buttons" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "a-cowCard__birthlist",
                                                attrs: {
                                                  href:
                                                    "https://adoptujkravicku.sk/hra/kravicka/rodny-list/" +
                                                    kravicka.id
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass: "a-cowCard__edit",
                                                attrs: {
                                                  to: {
                                                    name: "uprava-kravicky",
                                                    params: {
                                                      kravicka_id: kravicka.id,
                                                      kravicka_meno:
                                                        kravicka.kravicka_meno,
                                                      kravicka_meno_rodica:
                                                        kravicka.kravicka_meno_rodica
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }
                        ),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-banner__btn" }, [
      _c(
        "a",
        {
          staticClass: "btn --primary",
          attrs: { href: "http://adoptujkravicku.sk/kravicky/" }
        },
        [
          _vm._v(
            "\n                                Vyber si kravičku\n                            "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "a-cowCard__reserved" }, [
      _c("span", { staticClass: "icon" }),
      _vm._v("Nedokončená adopcia\n                                    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }